import { ACTION_TYPES } from "./constants";

export const initializeNavigationMiddleware = (navigate) => ({
  type: ACTION_TYPES.INITIALIZE_NAVIGATION_MIDDLEWARE,
  payload: navigate
});

export const navigateAction = (route, options) => ({
  type: ACTION_TYPES.NAVIGATE,
  payload: {
    route,
    options
  }
});
